import { MicrophoneIcon } from "@heroicons/react/24/outline";
import Button from "@ergeon/core-components/exports/Button.ts";

import { useAppContext } from '@/app/AppContext';
import NoMicrophone from '@/icons/NoMicrophone';
import { EVENTS, gtag } from '@/lib/gtag';

export default function ButtonMicrophone() {
  const appState = useAppContext();

  const onButtonClick = () => {
    appState.microphone.toggleDevice();

    gtag(EVENTS.TOGGLE_DEVICE, { device: 'microphone' });
  };

  const isEnabled = appState.microphone.isEnabled;

  return (
    <Button
      flavor={isEnabled ? "regular" : "danger"}
      isSquare
      onClick={onButtonClick}
      size="large"
      title="Microphone on/off">
      {isEnabled ? <MicrophoneIcon className="size-6" /> : <NoMicrophone className="size-6" />}
    </Button>
  );
}
